<div class="container-fluid blotter_top_interaction_bar" #topMenu *ngIf="searchEnabled">
  <div class="blotter_titlebar_interaction">
    <div class="blotter_filter_bar_container"></div>
    <div class="bfx-blotter-tools-container">
      <bfx-quick-search
        class="bfx-quick-search"
        [(ngModel)]="searchValue"
        (ngModelChange)="onChangeSearchValue()"
      ></bfx-quick-search>
    </div>
  </div>
</div>
<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    [frameworkComponents]="frameworkComponents"
    multiSortKey="ctrl"
    enableColResize
    enableSorting
    rowHeight="22"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
  >
  </ag-grid-angular>
</div>

<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
